import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// SDBC Imports
import { BcFloatMenuComponent } from '@bancolombia/design-system-web/bc-float-menu';
import { BcFooterComponent } from '@bancolombia/design-system-web/bc-footer';
import {
  BcHeaderComponent,
  BcHeaderListComponent,
  BcHeaderLeftComponent,
  BcHeaderItemMenuComponent,
  BcHeaderIconMenuComponent,
} from '@bancolombia/design-system-web/bc-header';
import { CONFIG } from '@bancolombia/design-system-web/bc-icon';
import { BcMenuComponent } from '@bancolombia/design-system-web/bc-menu';
import {
  BcCellDirective,
  BcTableContainerComponent,
  BcTableContentComponent,
  BcTableDirective,
  BcTableDropdownComponent,
  BcTableEmptyContainerComponent,
  BcTableFooterComponent,
  BcTableHeaderComponent,
} from '@bancolombia/design-system-web/bc-table';
import { BcPictogramComponent } from '@bancolombia/design-system-web/bc-pictogram';
import { BcRadioComponent, BcRadioGroupComponent } from '@bancolombia/design-system-web/bc-radio';
// MSAL module
import {
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from '@azure/msal-angular';
// Components
import { InformativeSubCategoryComponent } from './components/informative-sub-category/informative-sub-category.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { MainFooterComponent } from './shared/components/main-footer/main-footer.component';
import { MainHeaderComponent } from './shared/components/main-header/main-header.component';
import { MainMenuComponent } from './shared/components/main-menu/main-menu.component';
// Services
import { BcInputSelectComponent } from '@bancolombia/design-system-web/bc-input-select';
import { InformativeService } from './services/informative/informative.service';
import { HomeComponent } from './components/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { UserComponent } from './shared/components/user/user.component';
import { DevelopmentComponent } from './shared/components/development/development.component';
import { MainRedirectComponent } from './shared/components/main-redirect/main-redirect.component';
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';

const isIE =
  globalThis.navigator.userAgent.includes('MSIE') ||
  globalThis.navigator.userAgent.includes('Trident/');

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.azureConfig.clientId,
    authority: `${environment.azureConfig.loginMicrosoft}/${environment.azureConfig.tenantId}`,
    redirectUri: environment.azureConfig.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
});

const protectedResourceMap = new Map<string, string[]>(
  Object.entries(environment.azureConfig.sendTokenTo),
);

@NgModule({
  declarations: [
    AppComponent,
    MainHeaderComponent,
    InformativeSubCategoryComponent,
    UserDashboardComponent,
    HomeComponent,
    PageNotFoundComponent,
    UserComponent,
    DevelopmentComponent,
    MainRedirectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    // SDBC Imports
    MainFooterComponent,
    BcMenuComponent,
    MainMenuComponent,
    BcFooterComponent,
    BcHeaderComponent,
    BcHeaderListComponent,
    BcHeaderLeftComponent,
    BcHeaderItemMenuComponent,
    BcHeaderIconMenuComponent,
    BcFloatMenuComponent,
    BcTableContainerComponent,
    BcRadioComponent,
    BcRadioGroupComponent,
    BcPictogramComponent,
    BcCellDirective,
    BcTableContentComponent,
    BcTableDirective,
    BcTableDropdownComponent,
    BcTableEmptyContainerComponent,
    BcTableFooterComponent,
    BcTableHeaderComponent,
    // MSAL module
    MsalModule.forRoot(
      msalInstance,
      {
        interactionType: InteractionType.Redirect,
        authRequest: { scopes: [environment.azureConfig.appScope] },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
      },
    ),
    BcInputSelectComponent,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    InformativeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    { provide: CONFIG, useValue: { path: '' } },
    provideAppInitializer(() =>
      inject<PublicClientApplication>(MSAL_INSTANCE).initialize(),
    ),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
